import React from "react";
import ReactDOM from "react-dom/client";

import "@/i18n";
import "@/index.css";
import App from "@/App";
import ThemeProvider from "@/components/ThemeProvider";
import { initAnalytics } from "@/lib/analytics";

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
